"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleType = exports.AlertActionTypes = exports.AlertTypes = void 0;
var AlertTypes;
(function (AlertTypes) {
    AlertTypes["Danger"] = "danger";
    AlertTypes["Info"] = "info";
    AlertTypes["Success"] = "success";
    AlertTypes["Warning"] = "warning";
})(AlertTypes = exports.AlertTypes || (exports.AlertTypes = {}));
var AlertActionTypes;
(function (AlertActionTypes) {
    AlertActionTypes["Add"] = "@ui-alert/Add";
    AlertActionTypes["Clear"] = "@ui-alert/Clear";
    AlertActionTypes["Hide"] = "@ui-alert/Hide";
    AlertActionTypes["Remove"] = "@ui-alert/Remove";
    AlertActionTypes["Show"] = "@ui-alert/Show";
    AlertActionTypes["Toggle"] = "@ui-alert/Toggle";
})(AlertActionTypes = exports.AlertActionTypes || (exports.AlertActionTypes = {}));
var ToggleType;
(function (ToggleType) {
    ToggleType["Hide"] = "hide";
    ToggleType["Show"] = "show";
})(ToggleType = exports.ToggleType || (exports.ToggleType = {}));
